import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

// Render the floating tutorial card (with backdrop) for a useGuidedTutorial
// instance. Pass `tutorial` from useGuidedTutorial(...) and an optional
// `titleId` for ARIA labelling. Render this once near the bottom of your
// component's JSX; it's a no-op when the tutorial isn't open.
const GuidedTutorialOverlay = ({ tutorial, titleId = 'guidedTutorialTitle' }) => {
  if (!tutorial.open || !tutorial.currentStepDef) return null;
  const { close, back, next, cardStyle, currentStep, totalSteps, currentStepDef } = tutorial;
  const isLast = currentStep === totalSteps - 1;
  return (
    <div className="epma-tutorial-overlay" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <div className="epma-tutorial-overlay__backdrop" onClick={close} />
      <Card className="epma-tutorial-card container-shadow" style={cardStyle}>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
            <div>
              <div className="epma-tutorial-card__eyebrow">
                Step {currentStep + 1} of {totalSteps}
              </div>
              <h4 id={titleId} className="mb-1">{currentStepDef.title}</h4>
            </div>
            <button type="button" className="epma-close-button" onClick={close} aria-label="Skip tutorial">
              <i className="bi bi-x-lg" aria-hidden="true" />
            </button>
          </div>
          <p className="mb-0">{currentStepDef.body}</p>
          <div className="epma-tutorial-card__actions">
            <Button type="button" variant="outline-secondary" onClick={close}>Skip</Button>
            <div className="d-flex gap-2 flex-wrap">
              <Button
                type="button"
                variant="outline-secondary"
                onClick={back}
                disabled={currentStep === 0}
              >
                Back
              </Button>
              <Button type="button" onClick={next}>
                {isLast ? 'Finish' : 'Next'}
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GuidedTutorialOverlay;
